// All the urls that are generated to user in the Watch Tower application

const urls = {
    home: '/',
    pages: {
        unifiedMovementSystem: '/unified-movement-system',
        unifiedInventoryMovement: '/unified-inventory-movement',
        trackingRequestPage: '/tracking-request',
        documentCenter: '/unified-inventory-movement/document-center',
        configureRackOverride: '/unified-inventory-movement/configure-rack-override',
        consumptionCPLDashboard: '/unified-inventory-movement/consumption-cpl',
        consumptionCPLSupersetDashboard: '/unified-inventory-movement/consumption-cpl/superset',
        inventoryView: '/inventory-view',
        requisitionView: '/inventory-movement-requests',
        requestInventoryMovement: '/request-inventory-movement',
        uip: '/uip',
        uip_page_config: '/uip/page-config/:screenShareUrlToken',
        uip_save_page_config: '/uip/save-config/:screenSaveUrlToken',
        woc_page_config: '/uip/woc-view/page-config/:screenShareUrlToken',
        uip_onebox: '/uip-onebox',
        ipn_detail_onebox: '/uip-onebox/allocated-inventory-details/:encodedString',
        ipn_detail: '/uip/allocated-inventory-details/:encodedString',
        woc_table_view_old: '/woc-view-old',
        woc_table_view: '/uip/woc-view',
        inventory_report: '/uip/export-inventory-report',
        inventory_report_onebox: '/uip-onebox/export-inventory-report',
        forecast_health_quicksight_url: 'https://w.amazon.com/bin/view/AWS_SCM/Inventory_Visibility/ForecastMetrics/Dashboard/',
        inventory_ui_sim_template: 'https://t.corp.amazon.com/create/templates/ee631f55-add8-46f4-83b3-d9e3a4020d34'
    }
};

export default urls;
